export default {
  seo: {
    home: {
      title: 'Artemida Studio — Creatieve digitale oplossingen',
      description:
        'Wij maken maatwerkwebsites van elke complexiteit: landingspagina’s, bedrijfswebsites en AI-assistenten.',
      keywords: 'webontwikkeling, landingspagina, bedrijfswebsite, AI',
    },
    // 🔽 nieuw: SEO voor de blogoverzichtspagina
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Inzichten over webontwikkeling, design, AI-assistenten en het bouwen van moderne bedrijfswebsites.',
      keywords: 'blog, webontwikkeling, design, ai, websites',
    },
  },

  header: {
    homeLink: 'Startpagina',
    aboutUsLink: 'Over ons',
    servicesLink: 'Diensten',
    ourProjectsLink: 'Onze projecten',
    contact: 'Contact',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription: 'Wij maken maatwerkwebsites van elke complexiteit',
    contactUs: 'Neem contact op',
  },
  aboutUsSection: {
    aboutUsTitle: 'Over ons',
    aboutUsDescription:
      "Bij Artemida Studio zijn we gespecialiseerd in het maken van maatwerk landingspagina's en corporate websites die bedrijven helpen een sterke online aanwezigheid op te bouwen. Onze missie is om moderne, functionele en visueel overtuigende oplossingen te leveren die zijn afgestemd op de behoeften van jouw merk.\n\n" +
      'Door creativiteit te combineren met de nieuwste technologieën en een persoonlijke aanpak, bouwen we websites die niet alleen esthetisch aantrekkelijk zijn, maar ook snel, gebruiksvriendelijk en volledig responsief.\n\n' +
      'Of je nu een conversiegerichte landingspagina of een professionele bedrijfswebsite nodig hebt, Artemida Studio brengt jouw visie tot leven met maatwerkoplossingen van hoge kwaliteit.\n\n' +
      'Kies voor professionaliteit en creativiteit – laten we samen jouw perfecte website bouwen!',
  },

  // Diensten (volledige sectie aangestuurd via i18n)
  services: {
    ourServices: 'Onze diensten',
    servicesDescription:
      'We zijn gespecialiseerd in het creëren van hoogwaardige, op maat gemaakte digitale oplossingen die jouw bedrijf vooruithelpen',
    contactUs: 'Neem contact op',
    items: [
      {
        key: 'landing',
        title: 'Landings-\n pagina',
        descriptionList: [
          'Een goed ontworpen landingspagina is een krachtig middel om klanten aan te trekken, conversies te verhogen en de online zichtbaarheid van je merk te versterken. Bij Artemida Studio maken we hoogwaardige, maatwerk landingspagina’s die aansluiten op jouw bedrijfsdoelstellingen.',
          '✔️ Modern & uniek design — Visueel opvallende, merkgetrouwe pagina’s die aandacht trekken.',
          '✔️ Hoge conversieratio — Geoptimaliseerde lay-outs en overtuigende CTA’s voor meer engagement.',
          '✔️ Snel & responsief — Bliksemsnelle performance en een naadloze ervaring op alle apparaten.',
          '✔️ SEO- & marketingklaar — Gebouwd volgens best practices om zichtbaarheid te vergroten en organisch verkeer aan te trekken.',
          '✔️ Volledig aanpasbaar — Elk detail afgestemd op jouw behoeften en merkidentiteit.',
        ],
      },
      {
        key: 'corporate',
        title: 'Bedrijf - \n swebsite',
        descriptionList: [
          'Een professionele bedrijfswebsite is essentieel om vertrouwen op te bouwen, je merk te presenteren en klanten te betrekken. Bij Artemida Studio ontwikkelen we maatwerk bedrijfswebsites die de waarden van je organisatie weerspiegelen en je laten opvallen in de digitale wereld.',
          '✔️ Professioneel & uniek design — Een strak, modern uiterlijk dat aansluit bij je merkidentiteit.',
          '✔️ Volledig aanpasbaar — Elk element ontworpen rond jouw zakelijke doelen en behoeften.',
          '✔️ Snel & veilig — Geoptimaliseerd voor snelheid, veiligheid en vlekkeloze prestaties.',
          '✔️ SEO- & marketingvriendelijk — Gebouwd volgens best practices om de online zichtbaarheid te vergroten en potentiële klanten te bereiken.',
          '✔️ Mobiel & gebruiksvriendelijk — Volledig responsief ontwerp voor een consistente ervaring op alle apparaten.',
          '✔️ Eenvoudig contentbeheer — Snelle updates via een gebruiksvriendelijk CMS.',
        ],
      },
      {
        key: 'ai',
        title: 'Integratie van AI-assistenten',
        descriptionList: [
          'Geef je website een boost met AI! Bij Artemida Studio integreren we geavanceerde AI-assistenten die de gebruikerservaring verbeteren, taken automatiseren en de betrokkenheid verhogen. Of je nu een slimme chatbot, geautomatiseerde support of AI-gestuurde aanbevelingen nodig hebt, wij bouwen naadloze oplossingen op maat van jouw business.',
          '✔️ Klantenservice 24/7 — AI-chatbots behandelen vragen op elk moment en verhogen de klanttevredenheid.',
          '✔️ Naadloze website-integratie — Werkt soepel binnen je site en breidt functionaliteit uit zonder verstoring.',
          '✔️ Gepersonaliseerde user experience — AI-gestuurde interacties, afgestemd op behoeften en voorkeuren van gebruikers.',
          '✔️ Leadgeneratie & meer omzet — Betrek bezoekers, verzamel leads en begeleid klanten naar een aankoop.',
          '✔️ Automatisering & efficiëntie — Stroomlijn processen, verlaag werkdruk en verkort reactietijden.',
          '✔️ Maatwerk AI-oplossingen — Volledig aanpasbaar aan je bedrijfsmodel en specifieke vereisten.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Laten we uw project bespreken',
    placeholderName: 'Naam',
    placeholderPhone: 'Telefoon',
    placeholderEmail: 'E-mail',
    placeholderMessage: 'Vertel ons over uw project',
    sendButton: 'Verzenden',
  },
};
